import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchBodySubstitutionPartQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodySubstitutionPart/patchBodySubstitutionPartQueryFunction';
import { IBodyPatchSubstitutionPartParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodySubstitutionPart/patchBodySubstitutionPartQuery.type';

export const patchBodySubstitutionPartQueryOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  IBodyPatchSubstitutionPartParams
> => ({
  mutationKey: ['patchBodySubstitutionPartQueryOption'],
  mutationFn: (params: IBodyPatchSubstitutionPartParams) =>
    patchBodySubstitutionPartQueryFunction(params),
});
